// Push tokens and notification read state.
import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

/** Mark notifications read; omit ids to mark the whole feed read. */
export async function markNotificationsRead(notificationIds?: string[]): Promise<{ ok: true }> {
  const call = httpsCallable<{ notificationIds?: string[] }, { ok: true }>(functions, 'markNotificationsRead');
  return (await call({ notificationIds })).data;
}

/** Register (or refresh) this device's FCM push token for the signed-in user. */
export async function registerPushToken(token: string, platform: string): Promise<{ ok: true }> {
  const call = httpsCallable<{ token: string; platform: string }, { ok: true }>(functions, 'registerPushToken');
  return (await call({ token, platform })).data;
}

/** Remove a device's FCM push token (on sign-out). */
export async function unregisterPushToken(token: string): Promise<{ ok: true }> {
  const call = httpsCallable<{ token: string }, { ok: true }>(functions, 'unregisterPushToken');
  return (await call({ token })).data;
}
